import {
  EmptyResponse,
  SendReportRequest,
  ChangeNickNameRequest,
  CheckUserNameRequest,
  CheckUserNameResponse,
  CheckValidEmailRequest,
  CheckValidEmailResponse,
  DeleteUserInfoRequest,
  SignUpResponse,
  UserInfoRequest,
  UserInfoResponse,
  UserState,
} from '~/types';
import { fetcher } from './config/fetcher';
import http, { httpPublic } from './config/http';

export const sendReport = async (request: SendReportRequest) => {
  return fetcher(() => http.post<EmptyResponse>(`/users-reports`, request));
};

export const fetchSaveUserInfo = async (request: UserState) => {
  return fetcher(() => httpPublic.post<SignUpResponse>('/users', request));
};

export const fetchGetUserInfo = async ({ fcm_token }: UserInfoRequest) => {
  return fetcher(() =>
    http.get<UserInfoResponse>('/users', {
      params: { fcm_token },
    }),
  );
};

export const fetchCheckEmail = async ({ email }: CheckValidEmailRequest) => {
  return fetcher(() =>
    httpPublic.get<CheckValidEmailResponse>('/users-check-email', {
      params: { email },
    }),
  );
};

export const fetchDeleteAccount = async ({
  leave_memo,
}: DeleteUserInfoRequest) => {
  return fetcher(() => http.delete<EmptyResponse>('/users'));
};

export const fetchCheckUserName = async ({
  username,
}: CheckUserNameRequest) => {
  return fetcher(() =>
    httpPublic.get<CheckUserNameResponse>('/users-check-name', {
      params: { name: username },
    }),
  );
};

export const fetchChangeNickName = async (request: ChangeNickNameRequest) => {
  return fetcher(() => http.put<EmptyResponse>('/users', request));
};

// 안쓰는 API
// export const fetchChangeLanguage = async (request: ChangeLanguageRequest) => {
//   return fetcher(() => http.put<EmptyResponse>('/users', request));
// };
